import { useIntl } from 'react-intl';
import { NextGenUiToggle as CommonNextGenUiToggle } from '@fe-learner-common';
import { publishAnalyticsEvent } from '@fe-core-events';

export const NextGenUiToggle = ({ isLoading }: { isLoading: boolean }) => {
  const intl = useIntl();

  const handleToggle = () => {
    publishAnalyticsEvent({
      application: 'fe-learner-catalog',
      track: {
        event: {
          context: 'NextGenUIToggle',
          action: 'Disable',
        },
      },
    });
  };

  return (
    <CommonNextGenUiToggle
      isLoading={isLoading}
      onChange={handleToggle}
      texts={{
        label: intl.formatMessage({
          id: 'learner.common.nextgenui.toggle.prominent',
        }),
        description: intl.formatMessage({
          id: 'learner.common.nextgenui.toggle.description',
        }),
        beta: intl.formatMessage({
          id: 'learner.common.nextgenui.toggle.beta',
        }),
      }}
    />
  );
};
